module.exports = __webpack_public_path__ + "static/media/AmeenTanoli.6985c20e.jpeg";